/**
 * Per-browser dismissal for the Playground course promo strip (`GR-PGP01`),
 * the same one-key `localStorage` pattern as `site-notice-dismissal.ts`: the
 * key holds the last-dismissed campaign id, so a new campaign (a new id from
 * the admin, or a content hash that moved because the copy did) shows again
 * without a key rename. Unlike the site notice, a dismissal here can be
 * undone from the collapsed pill, hence `clearPlaygroundPromoDismissed`.
 */

export const PLAYGROUND_PROMO_DISMISSAL_KEY = "progsity:playground-promo:dismissed";
const KEY = PLAYGROUND_PROMO_DISMISSAL_KEY;

export function isPlaygroundPromoDismissed(id: string): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(KEY) === id;
  } catch {
    return false;
  }
}

export function persistPlaygroundPromoDismissed(id: string): void {
  try {
    window.localStorage.setItem(KEY, id);
  } catch {
    /* quota / private mode: the strip comes back next visit, which is fine */
  }
}

export function clearPlaygroundPromoDismissed(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* nothing to undo */
  }
}
